import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./Home.css";
import { motion } from "framer-motion";
import WeekDisplay from "./Home3.js";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

function Home1() {
  const today = new Date();
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedLmpDate, setSelectedLmpDate] = useState(null);
  const [selectedOption, setSelectedOption] = useState("dueDate");
  const [weekNo, setWeekNo] = useState(null);
  const [isCalculated, setIsCalculated] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const handleLmpSelection = () => {
    setSelectedOption("lmpDate");
    setSelectedDate(null);
    setSelectedLmpDate(null);
  };

  const handleDueDateSelection = () => {
    setSelectedOption("dueDate");
    setSelectedLmpDate(null);
    setSelectedDate(null);
  };

  const calculateCurrentWeek = (selectDate) => {
    const currentDate = new Date();
    const diffTime = currentDate - selectDate;
    const diffDays = diffTime / (1000 * 3600 * 24);
    const weeks = Math.floor(diffDays / 7);

    return weeks > 40 ? 40 : weeks < 0 ? 0 : weeks;
  };

  const handleCalculate = () => {
    if (selectedOption === "dueDate" && !selectedDate) {
      setShowTooltip(true);
      setTimeout(() => setShowTooltip(false), 2000);
      return;
    }
    if (selectedOption === "lmpDate" && !selectedLmpDate) {
      setShowTooltip(true);
      setTimeout(() => setShowTooltip(false), 2000);
      return;
    }
    let weeks = 0;

    if (selectedOption === "dueDate" && selectedDate) {
      const diffTime = selectedDate - today;
      const diffDays = diffTime / (1000 * 3600 * 24);
      weeks = Math.floor(diffDays / 7);
      weeks = weeks > 40 ? 40 : weeks < 0 ? 0 : weeks;
    } else if (selectedOption === "lmpDate" && selectedLmpDate) {
      weeks = calculateCurrentWeek(selectedLmpDate);
    }

    setWeekNo(weeks);
    setIsCalculated(true);
    window.scrollBy({ top: 400, behavior: "smooth" });
  };

  return (
    <div>
      <Row className="home-container">
        <Col className="col-2 heads1"></Col>
        <Col className="col-8 py-5 heads2">
          <h1
            className="head-home-track"
            style={{
              color: "#B24C76",
              textTransform: "initial",
            }}
          >
            Track your due date week by week
          </h1>
          <h2 className="text-cent" style={{ color: "black" }}>
            The Pregnancy Basics You Need to Know!
          </h2>

          <div className="radio-options">
            <div className="rd-opt">
              <input
                className="form-check-input"
                type="radio"
                name="radioGroup"
                id="radioOption1"
                value="dueDate"
                checked={selectedOption === "dueDate"}
                onChange={handleDueDateSelection}
              />
              <label htmlFor="radioOption1" className="checkbox-label">
                Due Date
              </label>
            </div>

            <div className="rd-opt">
              <input
                className="form-check-input"
                type="radio"
                name="radioGroup"
                id="radioOption2"
                value="lmpDate"
                checked={selectedOption === "lmpDate"}
                onChange={handleLmpSelection}
              />
              <label htmlFor="radioOption2" className="checkbox-label">
                LMP Date
              </label>
            </div>
          </div>

          <div className="date-picker-container">
            {selectedOption === "dueDate" && (
              <div className="select-due-date">
                <label className="select-label">Select Due Date:</label>
                <DatePicker
                  selected={selectedDate}
                  onChange={(date) => setSelectedDate(date)}
                  dateFormat="dd-MM-yyyy"
                  className="form-control"
                  placeholderText="Select Due Date"
                  minDate={today}
                  maxDate={
                    new Date(
                      today.getFullYear(),
                      today.getMonth() + 10,
                      today.getDate()
                    )
                  }
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>
            )}

            {selectedOption === "lmpDate" && (
              <div className="select-lmp-date">
                <label className="select-label">Select LMP Date:</label>
                <DatePicker
                  selected={selectedLmpDate}
                  onChange={(date) => setSelectedLmpDate(date)}
                  dateFormat="dd-MM-yyyy"
                  className="form-control"
                  placeholderText="Select LMP Date"
                  minDate={
                    new Date(
                      today.getFullYear(),
                      today.getMonth() - 9,
                      today.getDate()
                    )
                  }
                  maxDate={today}
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>
            )}
          </div>

          <div className="justify-center">
            <OverlayTrigger
              placement="top"
              overlay={
                showTooltip ? (
                  <Tooltip id="tooltip">Please select a date</Tooltip>
                ) : (
                  <></>
                )
              }
            >
              <button className="calculate-button" onClick={handleCalculate}>
                {isCalculated ? "RE CALCULATE" : "CALCULATE"}
              </button>
            </OverlayTrigger>
          </div>
        </Col>
        <Col className="col-2"></Col>
      </Row>

      {/* Conditionally render WeekDisplay */}
      {isCalculated && <WeekDisplay weekNo={weekNo} />}
    </div>
  );
}

export default Home1;
